import { defineComponent as _defineComponent } from 'vue'
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import Chart from '../Charts/Chart.vue';
import {
  BendProductivityFiguresData,
  BendProductivityFiguresName,
} from '@/models/Charts/chartsData';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import ValueTrend from '@/components/common/ValueTrend.vue';
import { isEmpty } from '@/utils/misc';
import BendProductivityFiguresChartGenerator from '@/models/Charts/bendProductivityFiguresChartGenerator';
import { weightUnit } from '@/utils/measurement';
import { timeFilterToUnitKeyMap } from './timeFilterToUnitKeyMap';
import { useAutoRemovedResizeListener } from '@/composables/misc';
import { computed, ref } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BendProductivityFigures',
  props: {
    data: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    dataRetriever: null
  },
  setup(__props: any) {

const props = __props as {
  data: BendProductivityFiguresData[] | null;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  /**
   * Chart generator to generate the heatmap charts.
   *
   * Not used to fetch the data. It comes from `data` prop instead.
   */
  dataRetriever: BendProductivityFiguresChartGenerator;
};

/**
 * Table with a heatmap chart, current and previous values, and the percentage
 * difference since the previous value.
 */



const forceRerenderKey = ref(1);

// HACK: Forces the re-rendering of the component so the table doesn't
// overflow the widget card when the screen orientation changes on a tablet.
useAutoRemovedResizeListener(forceRerender);

const { t, tc } = useI18n();

function getFigureUnits(figureEntry: BendProductivityFiguresData): string {
  switch (figureEntry.name) {
    case BendProductivityFiguresName.BendCount:
    case BendProductivityFiguresName.ToolChangesCount:
      return `/${tc(
        timeFilterToUnitKeyMap[props.widgetDefinition.timeFilterEnumValue!],
        1,
      )}`;
    case BendProductivityFiguresName.ProducedWeight:
    case BendProductivityFiguresName.WeightHandledByOperator:
    default:
      return (
        weightUnit() +
        `/${tc(
          timeFilterToUnitKeyMap[props.widgetDefinition.timeFilterEnumValue!],
          1,
        )}`
      );
  }
}

function formatValue(
  value: number,
  figureName: BendProductivityFiguresName,
): string {
  return BendProductivityFiguresChartGenerator.formatValue(value, figureName);
}

function formatCurrentValue(figureEntry: BendProductivityFiguresData): string {
  return formatValue(figureEntry.currentTotalValue, figureEntry.name);
}

function formatPreviousValue(figureEntry: BendProductivityFiguresData): string {
  return formatValue(figureEntry.previousTotalValue, figureEntry.name);
}

function getPeriodColumnHeader(periodPrefix: 'current' | 'previous'): string {
  return t(
    `bend_productivity_figures.${periodPrefix}_time_period.${periodKey.value}`,
  ).toString();
}

function isFigureTrendInverse(figureName: string): boolean {
  return figureName === 'tool-changes-count';
}

function forceRerender() {
  forceRerenderKey.value += 1;
}

const currentPeriodColumnHeader = computed(() =>
  getPeriodColumnHeader('current'),
);

const previousPeriodColumnHeader = computed(() =>
  getPeriodColumnHeader('previous'),
);

const periodKey = computed(
  () =>
    FilterTimeSpanEnum[props.widgetDefinition.timeFilter as FilterTimeSpanEnum],
);

const coalescedData = computed(() => props.data ?? []);

return { __sfc: true,props, forceRerenderKey, t, tc, getFigureUnits, formatValue, formatCurrentValue, formatPreviousValue, getPeriodColumnHeader, isFigureTrendInverse, forceRerender, currentPeriodColumnHeader, previousPeriodColumnHeader, periodKey, coalescedData, Chart, ValueTrend, isEmpty }
}

})